import { render, staticRenderFns } from "./AdminCompanyBoard.vue?vue&type=template&id=84b1cb4c"
import script from "./AdminCompanyBoard.vue?vue&type=script&lang=js"
export * from "./AdminCompanyBoard.vue?vue&type=script&lang=js"
import style0 from "./AdminCompanyBoard.vue?vue&type=style&index=0&id=84b1cb4c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports